import { useCallback } from 'react'
import fetchPDFFromService from '../utils/fetchPDF'
import useTracker from './useTracker'
import { MTM_EVENT_TYPES, MTM_FILE_TYPES, MTM_MULTI_PITCH, MTM_VARIABLES } from '../utils/matomo'

// single pitch reports send a 'pitch', multi pitch reports send a 'pitches' list (which can hold just one)
function getReportPitchLabel(payloadJSON) {
    const pitch = payloadJSON.pitch ?? (payloadJSON.pitches?.length === 1 ? payloadJSON.pitches[0] : undefined)
    return pitch ? `${pitch.name} (${pitch.id})` : MTM_MULTI_PITCH
}

// fetchPDFFromService, but tracks the download in matomo once the pdf was received
export default function useFetchPDF() {
    const track = useTracker()

    return useCallback(async (payloadJSON, fileName) => {
        const result = await fetchPDFFromService(payloadJSON, fileName)
        try {
            track({
                'event': MTM_EVENT_TYPES['file-download'],
                [MTM_VARIABLES['file-type']]: MTM_FILE_TYPES.pdf,
                [MTM_VARIABLES['report-type']]: payloadJSON.report?.reportType,
                [MTM_VARIABLES['report-pitch']]: getReportPitchLabel(payloadJSON),
            })
        } catch (e) { console.log(e) }
        return result
    }, [track])
}
